import React from "react";
import YellowBox from "../../../../assets/yellowCard.png";
import Ball from "../../../../assets/ball.png";

const Info = () => {
  return (
    <>
      <div>
        <InfoBox />
        <InfoBox />
        <InfoBox />
      </div>
      <div>
        <TimeBox half="HT" />
      </div>
      <div>
        <InfoBox />
        <InfoBox />
        <InfoBox />
      </div>
      <div>
        <TimeBox half="FT" />
      </div>
    </>
  );
};



export default Info;


const InfoBox = () => (
  <>
    <div className="info-box">
      <p>24`</p>
      <div className="flex justify-end">
        <div className="text-right mr-10">
          <p className="font-bold">Virgil Van Dijk</p>
          <label>Sadio Mane</label>
        </div>
        <div>
          <img src={Ball} />
        </div>
      </div>


      <div className="text-center">
        <p>1-0</p>
      </div>

      <div className="flex">
        <div className="mr-10">
          <img src={YellowBox} />
        </div>
        <div>
          <p className="font-bold">Raheem Sterling</p>
          <label>Gabriel Jesus</label>
        </div>
      </div>
    </div>
  </>
);

const TimeBox = ({half}) => (
  <>
    <div className="time-box">
      <p>{half}</p>
      <div>
        
      </div>
      <div className="text-center">
        <p>1-0</p>
      </div>
      <div>

      </div>
    </div>
  </>
);